// La porta del WhatsApp ufficiale di un'azienda (piano M6, R2, Task 6a; D3, D6, D10 e il ruling «Dominio neutro»): ciò che il
// prodotto chiede al fornitore per mandare un WhatsApp e per far approvare i modelli, in forma neutra. Nessun fornitore è
// nominato: identificativi, indirizzi, parametri e stati del fornitore stanno nell'adattatore del server
// (`apps/server/src/whatsapp/meta/`), che traduce da e verso questi tipi. Le operazioni che esistono soltanto presso il
// fornitore (la registrazione di un'azienda e dei suoi numeri, l'iscrizione ai webhook) stanno anch'esse nell'adattatore, con i
// nomi del fornitore. Un adattatore si crea per un'azienda, con il suo collegamento: i metodi non ripetono l'azienda.
//
// Ogni operazione risponde con un valore, `{ ok: true, … }` oppure `{ ok: false, code, retryable, message? }`: un errore del
// fornitore non è mai un'eccezione, e nessun esito porta il gettone di accesso o un altro segreto.
/**
 * Lo stato di un modello presso il fornitore, già tradotto dall'adattatore: `pending` in revisione, `approved` si può usare,
 * `rejected` rifiutato (con il motivo), `paused` sospeso dal fornitore per la qualità, `disabled` spento o cancellato. Uno stato
 * che l'adattatore non conosce non arriva qui: lo ignora. Sono gli stati della colonna `whatsapp_templates.meta_status`.
 */
export const WHATSAPP_TEMPLATE_STATUSES = ["pending", "approved", "rejected", "paused", "disabled"];
/** La lingua dei modelli: fissa finché i modelli dell'azienda sono in italiano (ruling «Dominio neutro»). */
export const WHATSAPP_TEMPLATE_LANGUAGE = "it";
/**
 * Il codice di un esito che non si sa (questione 415): il fornitore non ha risposto (rete, tempo scaduto) e la richiesta può
 * essere arrivata o no. Un invio con questo codice resta «Preso in carico» senza identificativo, non diventa `failed`: un
 * `failed` vero nasce soltanto da una risposta del fornitore. È sempre `retryable`.
 */
export const WHATSAPP_PROVIDER_NO_RESPONSE = "no_response";
/**
 * Il codice di un messaggio rimasto preso in carico senza la risposta del fornitore oltre il tempo dei giri di riconciliazione
 * («Non confermato», questione 415): il server si è fermato fra la richiesta e la risposta, e il messaggio può essere partito o no.
 */
export const WHATSAPP_NOT_CONFIRMED = "not_confirmed";
/**
 * I codici di un messaggio non riuscito che il fornitore può avere preso lo stesso (R9, «forse preso dal fornitore»): la risposta
 * persa e il «Non confermato». Con gli stati presi in carico, tengono il ritmo di WhatsApp Agile e contano nel suo tetto.
 */
export const WHATSAPP_MAYBE_TAKEN_FAILURES = [WHATSAPP_PROVIDER_NO_RESPONSE, WHATSAPP_NOT_CONFIRMED];
// Ciò che il fornitore rifiuta dentro il valore di una variabile: gli a capo (anche quelli di Unicode), le tabulazioni e gli
// altri separatori verticali; e più di quattro spazi di fila.
const LINE_BREAKS_AND_TABS = /[\t\n\v\f\r\u0085\u2028\u2029]+/g;
const MORE_THAN_FOUR_SPACES = / {5,}/g;
/**
 * Il valore di una variabile come il fornitore lo accetta (ruling «Pulizia dei parametri»): ogni fila di a capo e tabulazioni
 * diventa uno spazio, più di quattro spazi di fila diventano quattro, gli spazi ai lati si tolgono (come GioiaFlow, che però
 * riduce a uno spazio le file di quattro o più). La usano l'adattatore e il testo che si salva del messaggio, così in
 * `whatsapp_messages` c'è quello che il Lead riceve. Pulire due volte non cambia niente.
 */
export function cleanTemplateParameter(value) {
    return value.replace(LINE_BREAKS_AND_TABS, " ").replace(MORE_THAN_FOUR_SPACES, "    ").trim();
}
//# sourceMappingURL=whatsapp-provider.js.map